import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators, FormsModule } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule as MatDialogModule
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { LocalStorageService } from '../../../app/connectors/localstorage';
import { RequesSetupService } from '../../../app/services/request-setup.service';
import { UsersService } from '../../../app/services/users.service';
import { UserBehaviorService } from '../../services/user-events/user-behavior.service';
import { ModalSuccessComponent } from '../modal-success/modal-success.component';
import { ViewDetailsLoaderComponent } from '../view-details-loader/view-details-loader.component';
import Swal from 'sweetalert2';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-modal-view-detail-request-type',
  templateUrl: './modal-view-detail-request-type.component.html',
  styleUrls: ['./modal-view-detail-request-type.component.css'],
  standalone: true,
  imports: [
    NgFor,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    NgIf,
    MatOptionModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class ModalViewDetailRequestTypeComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  creationDate: any;
  createdBy: any;
  roleAcess: any;
  action: any;
  editMode: boolean = false;
  modalClose = new Subject<boolean>();
  optionsSelected: any;
  prioritiesSelected: any;
  owners: any;

  selectPriority: any = '';
  selectIcon: any = '';
  selectText: any = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private serviceLocalStorage: LocalStorageService,
    private requestService: RequesSetupService,
    private userService: UsersService,
    private userBehavior: UserBehaviorService
  ) {
    this.modalClose = new Subject<boolean>();
    let teamSelect = this.data.modal.select.find((select: any) => select.title === 'Team Name');
    let selectedTeamOption = teamSelect ? teamSelect.selectedOption : null;
    this.optionsSelected = selectedTeamOption;
    let teamSelectPriorities = this.data.modal.select.find((select: any) => select.title === 'Priorities');
    let selectedPriotiesOption = teamSelectPriorities ? teamSelectPriorities.selectedOption : null;
    this.prioritiesSelected = selectedPriotiesOption;

    this.processOwner(this.optionsSelected);
    this.changePriority(this.prioritiesSelected);
  }

  async ngOnInit(): Promise<void> {
    this.getRoleAcess();
    const user = await this.userBehavior.fromBehavior();
  }

  getRoleAcess() {
    this.roleAcess = this.serviceLocalStorage.decryptAndGet('roles-access');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  edit(edit: any) {
    if (edit.title.toLowerCase() !== 'ok') {
      this.editMode = true;
      this.updateDisabled(this.data.modal, false);
      this.action = edit.action;
    } else if (edit.title.toLowerCase() === 'ok') {
      this.closeDialog();
    }
  }

  compareAcess(req: any): boolean {
    return false;
  }

  updateDisabled(obj: any, state: boolean) {
    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (
            key === 'disabled' ||
            (obj['type'] == 'flag' && key !== 'title' && key !== 'statusFlag' && key !== 'value')
          ) {
            obj[key] = state;
          } else {
            this.updateDisabled(obj[key], state);
          }
        }
      }
    }
  }

  actionEdit(action: any) {
    if (action.title.toLowerCase() === 'cancel') {
      this.editMode = false;
      this.updateDisabled(this.data.modal, true);
    } else if (action.type.toLowerCase() === 'save-team') {
      const fieldToBodyMap = { requestName: 'Request Name', teamId: 'Team Name', shortName: 'Short Name' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    } else if (action.type.toLowerCase() === 'save-role') {
      const fieldToBodyMap = { roleName: 'Role Name' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    } else if (action.type.toLowerCase() === 'save-user') {
      const fieldToBodyMap = { userName: 'User Name', emailAddress: 'Email' };
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    } else if (action.type.toLowerCase() === 'save-request') {
      const fieldToBodyMap = this.getFieldToBodyMap(action.type.toLowerCase());
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    }
  }

  getFieldToBodyMap(type: string): { [fieldKey: string]: string } {
    switch (type) {
      case 'save-team':
      case 'create-team':
        return { teamName: 'Team Name' };
      case 'save-role':
      case 'create-role':
        return { roleName: 'Role Name' };
      case 'create-user':
        return { userName: 'User Name', emailAddress: 'Email Address', shortName: 'Short Name' };
      case 'create-priority':
        return { priorityName: 'Priority Name' };
      case 'save-request':
        return {
          estimatedDeadline: 'Estimated Deadline',
          priorityId: 'Priorities',
          requestName: 'Request Name',
          shortName: 'Short Name',
          teamId: 'Team Id',
          teamName: 'Team Name'
        };
      default:
        return {};
    }
  }

  save(path: any, body: any, fieldToBodyMap: { [fieldKey: string | number]: string | number }, actionType?: any) {
    for (const fieldKey in fieldToBodyMap) {
      if (fieldToBodyMap.hasOwnProperty(fieldKey)) {
        const field = this.data.modal.fields.find((field: any) => field.title === fieldToBodyMap[fieldKey]);
        const select = this.data.modal.select.find((field: any) => field.title === fieldToBodyMap[fieldKey]);
        if (field) {
          if (field.title === 'Short Name' && field.value) {
            body[fieldKey] = field.value.toUpperCase();
          } else {
            body[fieldKey] = field.value;
          }
        } else if (select) {
          body[fieldKey] = select.selectedOption;
        }
      }
    }
    body.statusFlag = this.data.modal.toggles[0].value === true ? 1 : 0;
    body.updatedBy = this.data.modal.idUser;

    if (actionType.type.toLowerCase() === 'save-team') {
      if (this.checkShortNameExists(body)) {
        this.errorUser();
        this.fecharModal();
        return;
      } else {
        body.createdBy = this.data.modal.idUser;
        this.actionSetup(path, body);
      }
    } else if (actionType.type.toLowerCase() === 'save-request') {
      body.createdBy = this.data.modal.idUser;
      body.estimatedDeadline = this.data.modal.fields[2].value;
      body.priorityId = this.data.modal.select[1].selectedOption;
      body.requestName = this.data.modal.fields[0].value;
      body.shortName = this.data.modal.fields[1].value;
      (body.teamId = this.data.modal.select[0].selectedOption),
        (body.requestOwnerId = this.data.modal.select[2].selectedOption);
      this.actionSetup(path, body);
    } else {
      body.createdBy = this.data.modal.idUser;
      this.actionSetup(path, body);
    }
  }

  checkShortNameExists(body: any): boolean {
    if (!body || !body.shortName || !this.data.shortName) {
      return false;
    }

    const shortNameExists = this.data.shortName.some((shortName: any) => {
      return shortName?.toString().toLowerCase() === body?.shortName.toString().toLowerCase();
    });
    return shortNameExists;
  }

  isShortNameValid(): boolean {
    const shortNameField = this.data.modal.fields.find((field: any) => field.title === 'Short Name');
    return !shortNameField || shortNameField.value?.length === 3;
  }

  actionSetup(path: any, body: any) {
    this.requestService.actionSetup(path, body).subscribe((resp: any) => {
      this.data.modal.fields.forEach((field: any) => {
        field.value = [''];
      });
      this.data.modal.select.forEach((select: any) => {
        select.selectedOption = [''];
      });
      this.fecharModal();
      this.openSuccessModal();
      this.closeDialog();
    });
  }

  openProgressDialog(text: any): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ViewDetailsLoaderComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: true,
        height: '250px',
        width: '600px',
        panelClass: 'center-modal',
        data: { modalClose$: this.modalClose, text: text }
      });

      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    });
  }

  openSuccessModal() {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      autoFocus: false,
      closeOnNavigation: true,
      disableClose: true,
      height: '250px',
      width: '700px',
      panelClass: 'center-modal'
    });

    dialogRef.afterOpened().subscribe(() => {});
  }

  fecharModal() {
    this.modalClose.next(true);
  }

  onValueChange(optionSelected: any, title: any) {
    this.optionsSelected = optionSelected;
    if (title.toLowerCase() === 'team name') {
      this.processOwner(this.optionsSelected);
    }
  }

  processOwner(id: any) {
    this.userService.processOwner(id).subscribe((resp) => {
      this.owners = resp;
    });
  }

  formatarId(field: string): string {
    return field.replace(/\s+/g, '-').toLowerCase();
  }

  errorUser() {
    Swal.fire({
      title: 'Error',
      text: 'This short description already exists. \nPlease choose a different characters.',
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6',
      customClass: 'custom-swal-error',
      footer:
        '<i class="icon-support"></i><a href="mailto:AM.US.OM.BusinessSolutions@global.ntt">click here to contact the support</a>'
    }).then(() => {});
  }

  changePriority(row: any) {
    if (row?.value) {
      this.selectPriority = row.value;
      this.selectIcon = row.icon;
      this.selectText = row.label;
    } else {
      if (row == 464896) {
        this.selectIcon = 'icon-priority-p1';
        this.selectText = 'High Priority';
      } else if (row == 866612) {
        this.selectIcon = 'icon-priority-p2';
        this.selectText = 'Medium Priority ';
      } else if (row == 876170) {
        this.selectIcon = 'icon-priority-p3';
        this.selectText = 'Low Priority ';
      }
    }
  }
}
